import "./App.css";
import "./Loader.scss";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import RouteWrapper from "./Wrapper/RouteWrapper";

import CodeInput from "./Pages/Login/CodeInput";
import Login from "./Pages/Login/Login";
import NotFound from "./Pages/Login/NotFound";
import CompanyDashboard from "./Pages/Dashboard/CompanyDashboard";

import EditAccount from "./Pages/Masters/EditAccount";
import FGDesignMaster from "./Pages/Masters/FGDesignMaster";
import AddFGDesign from "./Pages/Masters/AddFGDesign";
import EditFGDesign from "./Pages/Masters/EditFGDesign";

import BiltyOutward from "./Pages/Transactions/BiltyOutward";
import AddBiltyOutward from "./Pages/Transactions/AddBiltyOutward";
import EditBiltyOutward from "./Pages/Transactions/EditBiltyOutward";
import PackingChallan from "./Pages/Transactions/PackingChallan";
import AddPackingChallan from "./Pages/Transactions/AddPackingChallan";
import EditPackingChallan from "./Pages/Transactions/EditPackingChallan";

import StockReport from "./Pages/Reports/StockReport";
import StockQuickSummary from "./Pages/Reports/StockQuickSummary";
import StockSummary from "./Pages/Reports/StockSummary";
import StockDetail from "./Pages/Reports/StockDetail";
import PackingChallanReport from "./Pages/Reports/PackingChallanReport";
import SaleReport from "./Pages/Reports/SaleReport";

import Settings from "./Pages/Settings/Settings";
import { useEffect } from "react";
import BarcodeSettings from "./Pages/Settings/BarcodeSettings";
const KeyboardShortcuts = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {

      // Ctrl + D
      if (event.ctrlKey && event.key.toLowerCase() === "d") {
        event.preventDefault();
        navigate("/mnuFGDesign");
      }

      // Ctrl + P
      if (event.ctrlKey && event.key.toLowerCase() === "p") {
        event.preventDefault();
        navigate("/PackingChallan");
      }
      if (event.ctrlKey && event.key.toLowerCase() === "`") {
        event.preventDefault();
        navigate("/Settings");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  return null;
};

function App() {

  return (
    <>
      <BrowserRouter basename="/">
        <KeyboardShortcuts />
        <RouteWrapper
          childComponent={
            <Routes>
              <Route exact path="/" element={<CodeInput />} />
              <Route exact path="*" element={<NotFound />} />
              <Route path="/login/:token" element={<Login />} />
              {/* <Route path="/ForgotPassword" element={<ForgotPassword />} />
              <Route path="/ResetPassword" element={<ResetPassword />} />
              <Route path="/SelectCompany" element={<SelectCompany />} /> */}
              <Route path="/CompanyDashboard" element={<CompanyDashboard />} />

              <Route path="/mnuAccount" element={<EditAccount />} />
              <Route path="/mnuFGDesign" element={<FGDesignMaster />} />
              <Route path="/mnuFGDesign/AddFGDesign" element={<AddFGDesign />} />
              <Route path="/mnuFGDesign/EditFGDesign/:id" element={<EditFGDesign />} />

              <Route path="/BiltyOutward" element={<BiltyOutward />} />
              <Route path="/BiltyOutward/AddBiltyOutward" element={<AddBiltyOutward />} />
              <Route path="/BiltyOutward/EditBiltyOutward/:id" element={<EditBiltyOutward />} />
              <Route path="/PackingChallan" element={<PackingChallan />} />
              <Route path="/PackingChallan/AddPackingChallan" element={<AddPackingChallan />} />
              <Route path="/PackingChallan/EditPackingChallan/:id" element={<EditPackingChallan />} />

              <Route path="/StockReport" element={<StockReport />} />
              <Route path="/StockQuickSummary/:ids" element={<StockQuickSummary />} />
              <Route path="/StockSummary/:ids" element={<StockSummary />} />
              <Route path="/StockDetail/:ids" element={<StockDetail />} />
              <Route path="/PackingChallanReport" element={<PackingChallanReport />} />
              <Route path="/SaleReport" element={<SaleReport />} />

              {/* <Route path="/Settings" element={<Settings />} /> */}
              <Route path="/Settings" element={<BarcodeSettings />} />
            </Routes>
          }
        />
      </BrowserRouter>
    </>
  );
}

export default App;
